/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ThirdPartyCardCreateDto = {
    /**
     * Card chip number.
     */
    chipNumber: string;
    /**
     * Card number.
     */
    cardNumber: string;
    /**
     * Card valid to.
     */
    validTo: string;
    /**
     * Card type.
     */
    type: ThirdPartyCardCreateDto.type;
    /**
     * Card state.
     */
    state: ThirdPartyCardCreateDto.state;
};
export namespace ThirdPartyCardCreateDto {
    /**
     * Card type.
     */
    export enum type {
        BANK_CARD = 'BANK_CARD',
        IN_CARD = 'IN_CARD',
        HAULIER_CARD = 'HAULIER_CARD',
        MOBILE_PHONE = 'MOBILE_PHONE',
    }
    /**
     * Card state.
     */
    export enum state {
        ACTIVE = 'ACTIVE',
        BLOCKED = 'BLOCKED',
        EXPIRED = 'EXPIRED',
    }
}

